import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Default from './Default';

export default class NoScroll extends Default {
  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor() {
    super();
  }

  afterShow() {
    document.body.classList.add("__noScroll");
    this._isActive = true;
    this._setupAnchors();
    Scroll.show();
  }

  afterHide() {
    document.body.classList.remove("__noScroll");
    super.afterHide();
  }
}

ControllerPage._addPage("no-scroll", NoScroll)
